import { TablePlaceholder } from 'venn-ui-kit';
import React from 'react';
import { PlaceholderWrapper } from '../manage-data';

export const BulkManagementLoadingState = (
  <PlaceholderWrapper>
    <TablePlaceholder />
  </PlaceholderWrapper>
);
